import { http } from './http';
import { checkOrCreateChpoByDate, computeChpoDate } from './chpo';

// Краткие выводы CHPO (аналоги book/conclusions, но для CHPO)
export async function listChpoConclusions(params = {}) {
  const { data } = await http.get('chpo/conclusions/', { params });
  return data;
}

export async function getChpoConclusion(id) {
  const { data } = await http.get(`chpo/conclusions/${id}/`);
  return data;
}

export async function createChpoConclusion(payload) {
  const { data } = await http.post('chpo/conclusions/', payload);
  return data;
}

export async function updateChpoConclusion(id, payload) {
  const { data } = await http.patch(`chpo/conclusions/${id}/`, payload);
  return data;
}

export async function deleteChpoConclusion(id) {
  const { data } = await http.delete(`chpo/conclusions/${id}/`);
  return data;
}

// Получить conclusion из CHPO-контекста (через chpo/check/)
export async function getChpoConclusionFromContext(date) {
  const dateISO = date || computeChpoDate();
  const ctx = await checkOrCreateChpoByDate(dateISO);
  return ctx?.conclusion || null;
}